import fontkit from "@pdf-lib/fontkit";
import { PDFDocument } from "pdf-lib";
import { drawDebugBox, drawErrorBox } from "./drawErrorBox";
import { drawFillBox } from "./fillBox";
import { placeholderDrawMap } from "./placeholders";
import { DocumentPlaceholder, ModifyPdfOptions, PlaceholderType } from "./types";
import { isBrowser } from "./utils";
import { FontUrl } from "./index";

export async function modifyPdf(pdf: ArrayBuffer, placeholders: DocumentPlaceholder[], options: ModifyPdfOptions) {
  const pdfDoc = await PDFDocument.load(pdf);

  const fontBytes = await getFont();
  pdfDoc.registerFontkit(fontkit);
  const customFont = await pdfDoc.embedFont(fontBytes, { subset: true });

  const pages = pdfDoc.getPages();

  await Promise.all(
    placeholders.map(async (placeholder) => {
      const page = pages[placeholder.page - 1] ?? null;
      if (page) {
        try {
          if (placeholder.fillBox) {
            await drawFillBox(page, placeholder);
          }
          await placeholderDrawMap[placeholder.type]?.(page, placeholder, { pdfDoc, font: customFont, ...options });
          if (options.debugBoxes) {
            drawDebugBox(page, placeholder);
          }
        } catch (e) {
          drawErrorBox(page, placeholder);
          if (options.throwOnError) {
            throw e;
          } else {
            console.error(e);
          }
        }
      }
    })
  );

  return pdfDoc.save();
}

const getFont = async () => {
  const url = FontUrl;
  if (isBrowser()) {
    const res = await fetch(url.href);
    return res.arrayBuffer();
  }
  const fs = await import("fs");
  return fs.readFileSync(__dirname + url.pathname).buffer;
};

export const isType = <TOptions>(
  placeholder: DocumentPlaceholder,
  type: PlaceholderType
): placeholder is DocumentPlaceholder<TOptions> => placeholder.type === type;
